import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
import Footer from '../components/footer';
// 碎片组件
import Chip from 'Chip';
const BottomFooter = ({ content }) => {

    const { footer, isBiz } = content;

return (
        // <div className={styles.wrap}>
        //     <div className={styles.footerLink}>
        //         <a href="https://www.ifeng.com/corp/about/intro/" target="_blank" className={styles.nolpad} rel="noreferrer">
        //             凤凰新媒体介绍
        //         </a>
        //         <a href="https://ir.ifeng.com/" target="_blank" rel="noreferrer">
        //             投资者关系 Investor Relations
        //         </a>
        //         <a href="https://www.ifeng.com/corp/ad/" target="_blank" rel="noreferrer">
        //             广告服务
        //         </a>
        //         <a href="https://career.ifeng.com/" target="_blank" rel="noreferrer">
        //             诚征英才
        //         </a>
        //         <a href="https://www.ifeng.com/corp/privacy/" target="_blank" rel="noreferrer">
        //             保护隐私权
        //         </a>
        //         <a href="https://www.ifeng.com/corp/exemption/" target="_blank" rel="noreferrer">
        //             免责条款
        //         </a>
        //         <a href="https://www.ifeng.com/corp/feedback/" target="_blank" rel="noreferrer">
        //             意见反馈
        //         </a>
        //         <a href="https://phtv.ifeng.com/intro/" target="_blank" className={styles.noborder} rel="noreferrer">
        //             凤凰卫视介绍
        //         </a>
        //     </div>
        //     <div className={styles.copyright}>
        //         凤凰新媒体 版权所有 Copyright © 2016 Phoenix New Media Limited All Rights Reserved.
        //     </div>
        // </div>
        <div className={styles.footer}>
            {isBiz ? (
                <Footer content={footer} />
            ) : (
                <Chip id="20012" type="struct" title="底部公用版权" groupName="底部" content={footer}>
                    <Footer />
                </Chip>
            )}
        </div>
    );
};

BottomFooter.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(BottomFooter);
